import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _SubMacroProcess } from '../../../core/services/dataBean/EntityCatalog';
import { _HiringModality, _PaymentRequirement } from '../../../core/services/dataBean/EntityCatalogVdos';



interface Props {

    idSelector: number;
    onChange: any;
    label?: string;
    disable?: boolean;
}

export const SelectModalityNewSer = ({ idSelector, onChange, label, disable }: Props) => {

    const SelectModalityNewSer = useDataBean(_HiringModality)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector)
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {
        SelectModalityNewSer.instance.getHiringModalityRender(null, {}).then(
            (resp) => {
                setLista(resp)
            }
        )

    }

    return (
        <>
            <label>{label ?? "Modalidad"}</label>
            <select className="form-select" disabled={disable} value={id} onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                setValue(valor)
            }}>
                <option value={""}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDHiringModality} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}